import { render, staticRenderFns } from "./SelectCountries.vue?vue&type=template&id=5d85145e"
import script from "./SelectCountries.vue?vue&type=script&lang=js"
export * from "./SelectCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports